export default __webpack_public_path__ + "static/media/undraw_medicine_b-1-ol.22cf6f8d.svg";